/**
 * Array<Array<{
 *   ariaRef: AriaRef,
 *   element: Element
 * }>>
 */
export default [];
